enum Mutations {
  SET_POSITIONS = 'setPositions',
  UPDATE_POSITIONS = 'updatePositions',
  OPEN_POSITION = 'openPosition',
  CLOSE_POSITION = 'closePosition',
}

export default Mutations;
